import { render, staticRenderFns } from "./AddEditContractTemplateModal.vue?vue&type=template&id=54c10f7f&scoped=true"
import script from "./AddEditContractTemplateModal.vue?vue&type=script&lang=js"
export * from "./AddEditContractTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditContractTemplateModal.vue?vue&type=style&index=0&id=54c10f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c10f7f",
  null
  
)

export default component.exports